import { FAQItem } from "@/components/faq/faq-item";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export type FAQItemData = {
  itemId: string;
  title: string;
  content: ReactNode;
};

export type FAQContainerProps = {
  items: FAQItemData[];
  groupId?: string;
  showText?: string;
  hideText?: string;
  compact?: boolean;
  variant?: "cards" | "rows";
  className?: string;
};

export function FAQContainer({
  items,
  groupId,
  showText,
  hideText,
  compact,
  variant = "cards",
  className,
}: FAQContainerProps) {
  return (
    <div
      className={cn("flex flex-col", variant === "cards" && "gap-4", className)}
    >
      {items.map((item) => (
        <FAQItem
          key={item.itemId}
          itemId={groupId ? `${groupId}_${item.itemId}` : item.itemId}
          title={item.title}
          content={item.content}
          showText={showText}
          hideText={hideText}
          compact={compact}
          variant={variant}
        />
      ))}
    </div>
  );
}

FAQContainer.displayName = "FAQContainer";
